import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "../components/site/Header";
import { Footer } from "../components/site/Footer";

export default function NotFound() {
    return (
        <div className="bg-brand-cream min-h-screen" data-testid="not-found-page">
            <Header />
            <main className="max-w-3xl mx-auto px-4 py-32 text-center">
                <div className="font-display font-medium text-7xl text-brand-orange">
                    404
                </div>
                <h1 className="mt-4 font-display font-medium text-4xl text-brand-ink">
                    Esta página derreteu.
                </h1>
                <p className="mt-4 text-brand-ink-soft">
                    O endereço que procuras não existe ou foi movido.
                </p>
                <Link
                    to="/"
                    data-testid="not-found-home-link"
                    className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-ink hover:bg-[#2C312E] text-brand-cream px-7 py-4 text-sm font-semibold transition-all"
                >
                    <ArrowLeft className="h-4 w-4" /> Voltar ao início
                </Link>
            </main>
            <Footer />
        </div>
    );
}
